const getPrefCities = state => state?.resumeData?.perfCityList
const getListOfAllColleges = state => state?.resumeData?.AllCollegeList
const getCorporateList = state => state?.resumeData?.corporateList
const getListOfAllCollegesCurCourse = state => state?.resumeData?.CollegeList
const getPromotion = state => state?.resumeData?.promotionData



const selectors = {
    getPrefCities,
    getListOfAllColleges,
    getCorporateList,
    getListOfAllCollegesCurCourse,
    getPromotion
}

export default selectors